export default {
  items: [
    {
      name: 'Dashboard',
      url: '/',
      icon: 'icon-speedometer',
      badge: {
        variant: 'info',
        text: 'NEW',
      },
    },
    {
      name: 'Clients',
      icon: 'icon-people',
      children: [
        {
          name: 'All Clients',
          url: '/clients',
        },
        {
          name: 'Add New',
          url: '/clients/new'
        }
      ]
    },
    {
      name: 'GST',
      icon: 'icon-calculator',
      children: [
	{
          name: 'GST Accounts',
          url: '/gst'
        },
	{
          name: 'TDS',
          url: '/gst/tds'
        }
      ]
    },
    {
      name: 'Billing',
      icon: 'icon-calculator',
      children: [
	{
          name: 'All Bills',
          url: '/billing',
        }
      ]
    },
    {
      name: 'Services',
      icon: 'icon-calculator',
      children: [
	{
          name: 'All Services',
          url: '/services',
        },
        {
          name: 'Add New',
          url: '/services/new'
        }
      ]

    }


  ],
};



// WEBPACK FOOTER //
// ./src/_nav.js